import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const JSTClock: React.FC = () => {
  const { language } = useLanguage();
  const [jstTime, setJstTime] = useState<Date>(new Date());

  useEffect(() => {
    // Update time every second
    const interval = setInterval(() => {
      const now = new Date();
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      const jst = new Date(utc + (3600000 * 9)); // Add 9 hours for JST
      setJstTime(jst);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = () => {
    const hours = jstTime.getHours().toString().padStart(2, '0');
    const minutes = jstTime.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const getLabel = () => {
    if (language === 'zh') return '当地时间';
    if (language === 'ja') return '現地時刻';
    return 'Local Time';
  };

  return (
    <div className="flex items-center gap-2">
      <svg className="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className={`text-sm font-medium text-gray-700 ${language === 'zh' ? 'font-chinese-sans' : language === 'ja' ? 'font-japanese-sans' : 'font-sans'}`}>
        {getLabel()}: <span className="font-mono">{formatTime()}</span> <span className="text-gray-500">(UTC+9)</span>
      </span>
    </div>
  );
};
